<template>
    <div class="row">
        <div class="col-lg-12" v-if="error">
            <div class="alert alert-danger alert-dismissible fade show" role="alert">
                {{ error }}
                <button type="button" class="close" data-dismiss="alert" aria-label="Close"></button>
            </div>
        </div>
        <div class="col-lg-6">
            <div class="form-group">
                <el-select
                    v-model="inputValue"
                    filterable
                    clearable
                    placeholder="Entrez un mot-clé">
                    <el-option
                        v-for="item in list"
                        :key="item.id"
                        :label="item.name"
                        :value="item.id">
                    </el-option>
                </el-select>
                <input type="hidden" :value="inputValue" :name="name">
                <!-- <input type="hidden" v-model="allergenes_ids_string" name="allergene"> -->
                <!-- truc : {{ value }} -->
            </div>
        </div>
    </div>
</template>
<script>
export default {
    data() {
        return {
            list: [],
            inputValue: null,
        }
    },
    props: {
        error: {
            default: null
        },
        value:{
            default: null
        },
        name:{
            required: true,
        },
        url:{
            required: true
        },
    },
    mounted(){
        this.inputValue = this.value ? parseInt(this.value) : null
        axios.get(this.url).then((r)=>{
            this.list = r.data.data
        }).catch((e)=>{
            console.error(e)
        }).then(()=>{
        })

    },
    methods: {

    }
}
</script>
<style lang="scss">
    .el-select{
        width: 100%;
    }
</style>


